import dayjs from "dayjs";

export const customFormat = (timestamp, now) => {
  const timestampDate = dayjs(timestamp);
  const diffMinutes = now.diff(timestampDate, "minute");
  const diffHours = now.diff(timestampDate, "hour");

  if (diffMinutes <= 0) {
    return "Just now";
  } else if (diffMinutes > 0 && diffMinutes < 60) {
    return `${diffMinutes} minutes ago`;
  } else if (diffHours > 0 && diffHours < 24) {
    return `${diffHours} hours ago`;
  } else {
    return timestampDate.format("YYYY-MM-DD HH:mm");
  }
};
